module.exports = __webpack_public_path__ + "img/dolmar_px.01fc45ea.png";